export const DEFAULT_COMMERCE_HUBUP_CHANNEL = {
  enabled: false,
  groupId: '',
  topicId: '',
};

export const DEFAULT_COMMERCE_HUBUP = {
  reservation: { ...DEFAULT_COMMERCE_HUBUP_CHANNEL },
  clickAndCollect: { ...DEFAULT_COMMERCE_HUBUP_CHANNEL },
};

export function normalizeCommerceHubup(raw) {
  const base = { ...DEFAULT_COMMERCE_HUBUP };
  if (!raw || typeof raw !== 'object') return base;

  for (const key of ['reservation', 'clickAndCollect']) {
    const block = raw[key];
    if (!block || typeof block !== 'object') continue;
    base[key] = {
      enabled: block.enabled === true,
      groupId: String(block.groupId ?? '').trim(),
      topicId: String(block.topicId ?? '').trim(),
    };
  }
  return base;
}

export function serializeCommerceHubupForSave(state) {
  return normalizeCommerceHubup(state);
}
